import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface MovieCardProps {
  movie: Movie;
  showDesc?: boolean;
  index?: number;
}

export default function MovieCard({ movie, showDesc = false, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-100 transition-colors hover:border-primary-400/70"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 影片海报`}
          title={`${movie.title} 剧情解析与推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-90"></div>

        <div className="absolute left-2.5 top-2.5 flex items-center gap-1 rounded-md bg-background-50/85 px-2 py-1 backdrop-blur-sm">
          <i className="ri-star-fill text-[11px] text-accent-500"></i>
          <span className="font-label text-xs font-semibold text-foreground-950">
            {movie.rating.toFixed(1)}
          </span>
        </div>

        {movie.collection.includes("new") && (
          <div className="absolute right-2.5 top-2.5 rounded-md bg-accent-500 px-2 py-1 font-label text-[10px] font-semibold uppercase tracking-wider text-background-50">
            NEW
          </div>
        )}

        <div className="absolute inset-x-0 bottom-0 p-3">
          <div className="flex flex-wrap items-center gap-1.5">
            <span className="rounded bg-primary-500/90 px-1.5 py-0.5 text-[10px] text-background-50">
              {movie.year}
            </span>
            {movie.genres.slice(0, 2).map((genre) => (
              <span
                key={genre}
                className="rounded bg-background-50/20 px-1.5 py-0.5 text-[10px] text-foreground-900 backdrop-blur-sm"
              >
                {genre}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-3.5">
        <h3 className="line-clamp-1 font-heading text-[15px] font-semibold text-foreground-950 transition-colors group-hover:text-accent-400">
          {movie.title}
        </h3>
        <p className="mt-1 line-clamp-1 font-label text-[11px] uppercase tracking-wider text-foreground-500">
          {movie.originalTitle}
        </p>
        {showDesc && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
            {movie.synopsis}
          </p>
        )}
        <div className="mt-auto flex items-center justify-between pt-3 text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-time-line text-xs"></i>
            {movie.duration} 分钟
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-xs"></i>
            {(movie.views / 1000).toFixed(1)}k
          </span>
        </div>
      </div>
    </Link>
  );
}